import * as type from "../types";

const initialState = {
    selectedRoutes: null,
    routes: null,
    currentRoute: null,
    showCurrentRoute: false
};

export default function(state = initialState, action) {
    switch(action.type) {
        case type.SET_MAP_ROUTES:
            return {
              ...state,
              routes: action.value
            };
        case type.SET_SELECTED_ROUTES:
            return {
                ...state,
                selectedRoutes: action.value,
            };
        case type.MARK_ROUTE_AS_SELECTED:
            return {
                ...state,
                routes: action.value
            };
        case type.UPDATE_START_ADDRESS:
            return {
                selectedRoutes: state.selectedRoutes.map(route => {
                    if(route.id === action.id)
                        route.trasa[0].adres = action.value;
                    return route;
                }),
                routes: state.routes.map(route => {
                    if(route.id === action.id)
                        route.trasa[0].adres = action.value;
                    return route;
                }),
            };
            case type.UPDATE_END_ADDRESS:
                return {
                    selectedRoutes: state.selectedRoutes.map(route => {
                        if(route.id === action.id)
                            route.trasa[route.trasa.length -1].adres = action.value;
                        return route;
                    }),
                    routes: state.routes.map(route => {
                        if(route.id === action.id)
                            route.trasa[route.trasa.length -1].adres = action.value;
                        return route;
                    }),
                };
        case type.SET_CURRENT_ROUTE:
            return {
                ...state,
                currentRoute: action.value
            };
        case type.CHANGE_SHOW_CURRENT_ROUTE:
            return {
                ...state,
                showCurrentRoute: action.value
            };
        default:
            return state;
    }
}